import { getAllTarif } from "App/Component/layout/MasterData/Tarif/helpers";
import { DEFAULT_VALUE_OPTION } from "App/constants";
import { useState, useEffect } from "react";

const useInitialTarif = (withSearch = false) => {
  const DEFAULT_OPTION = withSearch ? [] : DEFAULT_VALUE_OPTION("Tarif");

  const [state, setState] = useState(DEFAULT_OPTION);
  useEffect(() => {
    (async () => {
      const res = await getAllTarif();
      if (res) {
        const data = withSearch
          ? []
          : [
              {
                value: 0,
                label: "Pilih Tarif",
              },
            ];
        res.map((item) => {
          return data.push({
            value: item.id,
            label: item.name,
          });
        });

        setState(data);
      }
    })();
  }, [withSearch]);

  return state;
};

export default useInitialTarif;
